// Slides shown in a featured course/article cover when its impact slideshow is on.
// Every field is always set so Firestore never receives `undefined`.
export type ImpactSlide =
  | { id: string; type: "text"; text: string }
  | { id: string; type: "image"; imageUrl: string };

const newSlideId = () =>
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `slide-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const createImpactSlide = (type: ImpactSlide["type"]): ImpactSlide =>
  type === "text" ? { id: newSlideId(), type, text: "" } : { id: newSlideId(), type, imageUrl: "" };

export const usableImpactSlides = (slides: ImpactSlide[] | undefined): ImpactSlide[] =>
  (slides || []).filter((slide) => (slide.type === "text" ? slide.text.trim() : slide.imageUrl.trim()));
